import { render, staticRenderFns } from "./SwapsNew.vue?vue&type=template&id=28f91c96"
import script from "./SwapsNew.vue?vue&type=script&lang=ts"
export * from "./SwapsNew.vue?vue&type=script&lang=ts"
import style0 from "./SwapsNew.vue?vue&type=style&index=0&id=28f91c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports